import { AppState } from '../../types/store';
import { getActiveSection } from './sections';
import { getCurrentlyViewedFolderId } from './gallectionSection';
import { GallectionResourceType } from '@wix/da-shared-react/pkg/types/gallection';
import { ALL_FOLDER_ID } from '@wix/da-url';
import { ResourceType } from '@wix/da-shared-react/pkg/types/resource';
import { getProfileOwnerUser } from './users';

export function getBiExtraData(
  state: AppState
): { typeid: number; itemid: number } {
  const section = getActiveSection(state);

  switch (section) {
    case 'favourites':
    case 'gallery':
      let itemid = getCurrentlyViewedFolderId(state);
      let typeid: number =
        section === 'gallery'
          ? GallectionResourceType.GALLERY
          : GallectionResourceType.COLLECTION;

      if (!itemid || itemid === ALL_FOLDER_ID) {
        typeid = ResourceType.USER;
        itemid = getProfileOwnerUser(state).userId;
      }

      return {
        typeid,
        itemid,
      };
    default:
      return {
        typeid: ResourceType.USER,
        itemid: getProfileOwnerUser(state).userId,
      };
  }
}
